import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

//components:
import TopicsTable from "./Table";
import {CircularProgress} from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import {useDispatch, useSelector} from "react-redux";
import {fetchSettingsFeatures} from "../../../redux_slices/settingsFeaturesSlice";

const TopicsTableCard = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const settingsFeaturesStatus = useSelector(state => state.settingsFeatures.status);

    useEffect(() => {
        dispatch(fetchSettingsFeatures());
    }, []);

    let content;
    if (settingsFeaturesStatus.type === "succeeded") {
        content = (
            <div className="d-flex flex-column justify-content-center">
                <TopicsTable />
            </div>
        );
    } else if (settingsFeaturesStatus.type === "failed") {
        content = (
            <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100 z-index-2">
                <div
                    className={`alert alert-${settingsFeaturesStatus.error ||
                        "warning"} font-weight-bold w-fit-content d-flex align-items-center`}
                >
                    <WarningRoundedIcon color="inherit" className="mr-5" />
                    {t(settingsFeaturesStatus.error)}
                </div>
            </div>
        );
    } else {
        content = (
            <div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100 z-index-2">
                <CircularProgress />
            </div>
        );
    }
    return (
        <div className="col-12 col-md-9">
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray">
                    <div className="card-title">{t("ADMINPANEL.ICONS.TITLE")}</div>
                </div>
                <div className="card-body position-relative min-h-180px">{content}</div>
            </div>
        </div>
    );
};

TopicsTableCard.propTypes = {
    isLoading: PropTypes.bool,
    errorMessage: PropTypes.string,
};

export default TopicsTableCard;
